
<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title">
        <span cvLocalizedText langSection="Call_Arrival_Module" langKey="Slideout_Section_Title">Display</span>
    </div>
    <div class="custom-setting-section-context">{{ getSlideoutContextSectionText() }}</div>
    <div class="custom-setting-section-body">
        <div class="d-flex flex-nowrap align-items-center">
            <div cvLocalizedText langSection="Call_Arrival_Module" langKey="Show_Call_Arrival">Show call arrival for</div>
            <!-- Numeric input for hours. -->
            <input type="number" class="form-control mx-2" style="width: 72px; min-width: 72px; max-width: 72px;" id="callArrivalSettingsHours" required step="1" min="1" max="72"
             [(ngModel)]="settings.selectedHour" (blur)="resetInvalidHoursToDefault()"/>
            <label class="d-block m-0" for="callArrivalSettingsHours" cvLocalizedText langSection="Call_Arrival_Module" langKey="Hours_Prior_To">hours prior to</label>
        </div>
        <div class="d-flex flex-nowrap align-items-center mt-2">
            <!-- Prior-to Checkbox -->
            <input type="checkbox" class="form-control-check my-0 mx-2 p-0" [(ngModel)]="settings.useChosenDateTime" (click)="toggleUseEndDateTime()">

            <!-- Dummy calendar HTML to appear the same when the checkbox is not checked, did this because I could not disable the calendars on click method -->
            <div class="call-arrival-picker picker-disabled" style="min-width: 136.5px;" [hidden]="settings.useChosenDateTime"> 
                <div class="picker-value">{{ getDateDisplayValue() }}</div>
                <div class="picker-icon fill-whaleTail">
                    <svg class="icon-16 d-block">
                        <use href="../App_Themes/clearview-default/icons/utility/date.svg#date"></use>
                    </svg>
                </div>
            </div>

             <!-- actual calendar when checkbox is checked -->
            <div [hidden]="!settings.useChosenDateTime">
                <cv-baremetrics-calendar 
                    class="d-block daterange daterange--single" 
                    [(currentDate)]="settings.chosenDateTime"
                    [earliestDate]="startDate" 
                    [latestDate]="today"
                    (dateChanged)="onCustomDateRangeChanged()"
                    [required]="true"
                ></cv-baremetrics-calendar>
            </div>
             <!-- Dummy time picker HTML to appear the same when the checkbox is not checked -->
            <div class="call-arrival-picker ml-2 picker-disabled" style="min-width: 136.5px;" [hidden]="settings.useChosenDateTime">
                <div class="picker-value">Current</div>
                <div class="picker-icon fill-whaleTail">
                    <svg class="icon-16 d-block">
                        <use href="../App_Themes/clearview-default/icons/utility/time.svg#time"></use>
                    </svg>
                </div>
            </div>
            <!-- actual time picker -->
            <div style="width: 118px; padding-left: 8px;">
                <cv-time-picker  
                    [hidden]="!settings.useChosenDateTime"              
                    [(ngModel)]="selectedTime" 
                    (ngChange)="onSelectedTimeChanged(selectedTime)" 
                    >
                </cv-time-picker>
            </div>
        </div>
        <!-- new colors picker -->
        <div class="d-flex flex-nowrap align-items-center mt-4">
            <input type="checkbox" class="form-control-check my-0 mx-2 p-0" [(ngModel)]="settings.alignColorsToAgentStates">
            <div cvLocalizedText langSection="Call_Arrival_Module" langKey="Align_Colors_To_Agent_States">Align colors to agent states</div>
        </div>
    </div>
</cv-module-custom-setting-section>

<ng-container *ngIf="moduleManager.settingsView === 'modal'">
    <div cvModuleLegacyCustomSettingSection [moduleManager]="moduleManager" >
    <div class="callArrivalSettingsContent container" style="min-width: 635.7px">
        <!-- Hours -->
        <div class="callArrivalSettingsContent timeSpanArea">
            <label cvLocalizedText langKey="Show_Call_Arrival" langSection="Call_Arrival_Module" style="padding-right: 5px;">Show call arrival for</label>
            <select [(ngModel)]="settings.selectedHour" ng-options="hour for hour in $ctrl.hourList" style="min-width:60px; width:60px;" class="form-control">
                <option *ngFor="let hour of hourList" [ngValue]="hour">{{ hour }}</option>
            </select>
            <label cvLocalizedText langKey="Hours_Prior_To" langSection="Call_Arrival_Module" style="padding-right: 5px;">hours prior to</label>
            <input type="checkbox" 
                class="sgCustomCheckbox" 
                [(ngModel)]="settings.useChosenDateTime"
                (click)="toggleUseEndDateTime()"
                />

              <!-- Dummy calendar HTML to appear the same when the checkbox is not checked, did this because I could not disable the calendars on click method-->
              <div class="call-arrival-picker picker-disabled" style="min-width: 136.5px;" [hidden]="settings.useChosenDateTime">
                <div class="picker-value">{{ getDateDisplayValue() }}</div>
                <div class="picker-icon fill-whaleTail">
                    <svg class="icon-16 d-block">
                        <use href="../App_Themes/clearview-default/icons/utility/date.svg#date"></use>
                    </svg>
                </div>
            </div>

             <!-- actual calendar when checkbox is checked -->
            <div [hidden]="!settings.useChosenDateTime" style="width: 136.5px;">
                <cv-baremetrics-calendar 
                    class="d-block daterange daterange--single" 
                    [(currentDate)]="settings.chosenDateTime"
                    [earliestDate]="startDate" 
                    [latestDate]="today"
                    (dateChanged)="onCustomDateRangeChanged()"
                    [required]="true"
                ></cv-baremetrics-calendar>
            </div>
             <!-- Dummy time picker HTML to appear the same when the checkbox is not checked -->
            <div class="call-arrival-picker ml-2 picker-disabled" style="min-width: 136.5px;" [hidden]="settings.useChosenDateTime">
                <div class="picker-value">Current</div>
                <div class="picker-icon fill-whaleTail">
                    <svg class="icon-16 d-block">
                        <use href="../App_Themes/clearview-default/icons/utility/time.svg#time"></use>
                    </svg>
                </div>
            </div>
            <!-- actual time picker -->
            <div style="padding-left: 8px;">
                <cv-time-picker  
                    [hidden]="!settings.useChosenDateTime"               
                    [(ngModel)]="selectedTime" 
                    (ngChange)="onSelectedTimeChanged(selectedTime)" 
                    >
                </cv-time-picker>
            </div>
        </div>
    </div>
    </div>
</ng-container>
